import { InstantMessageChannelUserActiveState } from "../enums";
var InstantMessageChannelAddedUser = /** @class */ (function () {
    function InstantMessageChannelAddedUser(obj) {
        this.id = obj && obj.id || "";
        this.userId = obj && obj.userId || "";
        this.activeState = obj && obj.activeState || InstantMessageChannelUserActiveState.Rejected;
    }
    InstantMessageChannelAddedUser.createInstantMessageChannelAddedUser = function (id, userId, activeState) {
        var result = new InstantMessageChannelAddedUser();
        result.id = id;
        result.userId = userId;
        result.activeState = activeState;
        return result;
    };
    return InstantMessageChannelAddedUser;
}());
export { InstantMessageChannelAddedUser };
